export default "__VITE_ASSET__B27ncqVQ__"